import { render, staticRenderFns } from "./file copy.vue?vue&type=template&id=815c5b78&"
import script from "./file copy.vue?vue&type=script&lang=js&"
export * from "./file copy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports